<template>



  <v-card flat>
    <v-card-text>
      <v-select dense v-model="periodSelect" :items="periodItems" label="period" required></v-select>
    </v-card-text>
    <v-card-text v-if="customPeriod">
      <v-row>
        <v-col>
          <v-date-picker range v-model="dateModel" elevation="10" multiple></v-date-picker>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-title>
      Label Analysis -&nbsp;<span v-if="!allTime">
        from {{ prettyDate(viPeriodSelectStart) }} to {{ prettyDate(viPeriodSelectEnd)
        }}</span><span v-else>
        all time
      </span>
    </v-card-title>

    <v-card-title class="subtitle-1">Film summary</v-card-title>
    <v-data-table :headers="headers.filmSummary" :items="durationItem" dense disable-pagination hide-default-footer
      :loading="$apollo.loading" loading-text="Loading... Please wait">
      <template v-slot:item.durationSum="{ item }">
        {{ Math.round(item.durationSum) }}
      </template>
      <template v-slot:item.avgDuration="{ item }">
        {{ Math.round(item.avgDuration) }}
      </template>
      <template v-slot:item.avgLabels="{ item }">
        {{ Math.round(item.avgLabels) }}
      </template>
      <template v-slot:item.units="{ item }">
        {{ Math.round(item.units / 1000) }}
      </template>
    </v-data-table>
    <v-card-title class="subtitle-1">By label type</v-card-title>
    <v-data-table :headers="headers.type" :items="ViLabelsByType" dense disable-pagination hide-default-footer
      :loading="$apollo.loading" loading-text="Calculating type analysis...">
    </v-data-table>

  </v-card>


</template>
<script>

import { ViLabelsByFilm, ViLabelsByFilmSummary, ViLabelsByType } from '@/gql'
import { mapState, mapMutations, mapActions } from 'vuex'
import { vxMaps, patchStartOfDay, patchEndOfDay } from '@/js/vxstore'
import { SearchUtils } from '@/js'
const { formatDate } = SearchUtils

const NUMBER_OF_FEATURES = 6

const basicHeaders = [{
  text: "No. of masters",
  value: "masterCount",
  align: "end"
}, {
  text: "No. of labels detected",
  value: "labelCount",
  align: "end"
}];

const durationHeaders = [{
  text: "Total duration analyzed(secs)",
  value: "durationSum",
  align: "end"
}, {
  text: 'Average duration(secs)',
  value: 'avgDuration',
  align: 'end'
}, {
  text: 'Average labels',
  value: 'avgLabels',
  align: 'end'
}, {
  text: 'Units used (000)',
  value: 'units',
  align: 'end'
}];

const periodItems = [
  'All time',
  'This month',
  'Last month',
  'Today',
  'Yesterday',
  'Custom'
]

export default {
  props: {
    filmID: String
  },

  watch: {
    dateModel(value) {
      const a = value[0] ? new Date(value[0]) : null
      const b = value[1] ? new Date(value[1]) : null
      let start = a
      let end = b
      if (b && a && a.getTime() > b.getTime()) {
        start = b
        end = a
      }

      this.setViPeriodSelectStart(start ? patchStartOfDay(start) : start)
      this.setViPeriodSelectEnd(end ? patchEndOfDay(end) : end)
    }
  },
  computed: {
    durationItem() {
      if (!this.summary) return []
      return [{
        ...this.summary,
        avgDuration: this.avgDuration,
        avgLabels: this.avgLabels,
        units: this.units
      }]
    },
    summary() {
      return this.filmSummary && this.filmSummary.length && this.filmSummary[0]
    },
    units() {
      return this.durationSum * NUMBER_OF_FEATURES
    },
    masterCount() {
      return this.summary && this.summary.masterCount || 0
    },
    durationSum() {
      return this.summary && this.summary.durationSum || 0
    },
    labelCount() {
      return this.summary && this.summary.labelCount || 0
    },
    avgDuration() {
      return (this.masterCount && (this.durationSum / this.masterCount)) || 0
    },
    avgLabels() {
      return (this.masterCount && (this.labelCount / this.masterCount)) || 0
    },
    customPeriod() {
      return this.periodSelect === 'Custom'
    },
    allTime() {
      return this.periodSelect === 'All time'
    },
    periodSelect: {
      get() {
        return this.viPeriodSelect
      },
      set(value) {
        this.actionViPeriodSelect(value)
      }
    },
    periodSelectStart() {
      return this.viPeriodSelectStart && this.viPeriodSelectStart.toJSON()
    },
    periodSelectEnd() {
      return this.viPeriodSelectEnd && this.viPeriodSelectEnd.toJSON()
    },
    filmSummary() {
      return this.ViLabelsByFilmSummary && [this.ViLabelsByFilmSummary]
    },
    periodVariables() {
      const v = {
        from: this.viPeriodSelectStart ? this.viPeriodSelectStart.toISOString() : null,
        to: this.viPeriodSelectEnd ? this.viPeriodSelectEnd.toISOString() : null
      }
      return v
    },
    ...mapState(vxMaps.state)
  },
  methods: {
    prettyDate(dt) {
      return formatDate(dt)
    },
    ...mapMutations(vxMaps.mutations),
    ...mapActions(vxMaps.actions)
  },
  data: () => ({
    dateModel: [],
    periodItems,
    headers: {
      type: [{
        text: 'Label type',
        value: 'type'
      }, ...basicHeaders],
      filmSummary: [{
        text: "No. of films",
        value: "filmCount",
        align: "end"
      },
      ...basicHeaders,
      ...durationHeaders
      ]
    }
  }),
  apollo: {
    ViLabelsByFilmSummary: {
      query: ViLabelsByFilmSummary,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          ...this.periodVariables
        }
      }
    },
    ViLabelsByType: {
      query: ViLabelsByType,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          ...this.periodVariables
        }
      }
    },
    ViLabelsByFilm: {
      skip() {
        return !this.filmID
      },
      query: ViLabelsByFilm,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          ...this.periodVariables
        }
      }
    }
  }
}


</script>
